import { Link } from "react-router-dom";
import type { News } from "@/types/content";
import { formatDateCn } from "@/lib/content";

interface NewsCardProps {
  item: News;
  layout?: "row" | "column";
}

export default function NewsCard({ item, layout = "row" }: NewsCardProps) {
  if (layout === "column") {
    return (
      <Link
        to={`/detail/${item.id}`}
        className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
      >
        <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 影视资讯配图`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-[11px] px-2 py-0.5 rounded-md">
            {item.type}
          </span>
        </div>
        <div className="p-4 flex flex-col flex-1">
          <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {item.title}
          </h3>
          <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2 flex-1">
            {item.summary}
          </p>
          <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" />
              {formatDateCn(item.date)}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-user-line" />
              {item.source}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors p-3"
    >
      <div className="w-32 sm:w-40 shrink-0 aspect-[16/10] rounded-md overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 影视资讯配图`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="bg-primary-50 text-primary-600 text-[11px] px-2 py-0.5 rounded-md">{item.type}</span>
          <span className="text-xs text-foreground-500">{formatDateCn(item.date)}</span>
        </div>
        <h3 className="font-heading font-bold text-sm sm:text-base text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="text-xs sm:text-sm text-foreground-500 mt-1.5 leading-relaxed line-clamp-2 flex-1">
          {item.summary}
        </p>
        <span className="text-xs text-foreground-400 mt-1.5 hidden sm:block">来源：{item.source}</span>
      </div>
    </Link>
  );
}